import * as S from "./ExerciseInfo.style";
import { ReactComponent as IconTime } from "@/styles/assets/svg/icon_time.svg";
import { ReactComponent as IconPlay } from "@/styles/assets/svg/icon_play_arrow.svg";

interface ExerciseInfoProps {
  title: string;
  duration: number;
  onClick?: () => void;
}
export const ExerciseInfo = ({
  title,
  duration,
  onClick,
}: ExerciseInfoProps) => {
  const formatDuration = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    if (minutes === 0) {
      return `${remainingSeconds}초`;
    }

    return remainingSeconds > 0
      ? `${minutes}분 ${remainingSeconds}초`
      : `${minutes}분`;
  };

  return (
    <S.ExerciseInfo onClick={onClick}>
      <S.ExerciseInfoTxt>
        {title ? title : <span>오늘의 운동이 없습니다.</span>}
        {title && (
          <S.InfoTime>
            <IconTime /> 총 {formatDuration(duration)}
          </S.InfoTime>
        )}
      </S.ExerciseInfoTxt>

      {title && (
        <S.PlayBtn>
          <IconPlay width={28} height={28} />
        </S.PlayBtn>
      )}
    </S.ExerciseInfo>
  );
};
